import type { CompleteFieldSelector } from '@/types/fields-api.model';
import { Player } from '@/types/tournament.model';
import { SPORT_FIELDS } from '../sport/sport-fields.config';

const PLAYER_FIELDS_FULL: CompleteFieldSelector<Player> = {
  id: true,
  name: true,
  username: true,
  gender: true,
  email: true,
  rankings: {
    elo: true,
    sport: SPORT_FIELDS.FULL,
  },
  birthdate: true,
  cellphone: true,
  nationality: {
    isoCode: true,
    name: true,
    flag2: true,
    phonePrefix: true,
  },
  profileImageUrl: true,
};

export const PLAYER_FIELDS = {
  FULL: PLAYER_FIELDS_FULL,
} as const;
